/* eslint-disable no-throw-literal */
import apiClient from './apiClient.js';

export const getAppDomainUserAttrs = () => apiClient.get('/domain-users-attributes');
export const getAppDomainUserAttrById = (id) => apiClient.get(`/domain-users-attributes/${id}`);
export const getAppDomainUserAttrsAll = () => apiClient.get('/domain-users-attributes/all');
export const getAppDomainUserAttrAllById = (id) => apiClient.get(`/domain-users-attributes/${id}`);
export const updateAppDomainUserAttr = (id, data) => apiClient.put(`/domain-users-attributes/${id}`, data);
export const deleteAppDomainUserAttr = (id) => apiClient.delete(`/domain-users-attributes/${id}`);
export const deleteAppDomainUserAttrAll = (id) => apiClient.delete(`/domain-users-attributes/all/${id}`);
export const getAppDomainUserAttrByUserId = (id) => apiClient.get(`/domain-users-attributes/domain-user/${id}`);
export const getAppDomainUserAttrEmailById = (email) => apiClient.get(`/domain-users-attributes/email/${email}`);

export const createAppDomainUserAttr = async (data) => {
  try {
    const response = await apiClient.post('/domain-users-attributes', data);
    return response.data;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 409) {
          throw { type: 'duplicate', message: error.response.data?.error || 'El atributo de dominio ya existe ya existe.' };
      }
      throw { type: 'general', message: error.response.data?.error || 'Ha ocurrido un error, por favor intente nuevamente.' };
    }
    throw { type: 'general', message: 'Error de conexión, por favor intente nuevamente.' };
  }
};
